import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import Button from './Button';
import { SvgIcon } from '@material-ui/core';
import { Edit as EditIcon } from '@material-ui/icons';
import { isDarkMode } from '../../utils/helpers';
import colors from '../../theme/colors';
import breakpoints from '../../theme/material/breakpoints';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const StyledEditButton = styled(Button)(
  () => ({
    fontSize: '14px !important',
    color: isDarkMode() ? '#71B5E4 !important' : '#2B8FD7 !important',
    fontWeight: '600 !important',
    borderRadius: '6px !important',
    border: '1px solid #2B8FD7 !important',
    display: 'flex !important',
    alignContent: 'center !important',
    alignItems: 'center !important',
    padding: '12px !important',
    height: 32,
    cursor: 'pointer',
    lineHeight: '16px !important',
    marginBottom: 10,
    ':hover': {
      backgroundColor: isDarkMode() ? `${colors.blue[600]} !important` : `${colors.blue[500]} !important`,
      color: isDarkMode() ? `${colors.blue[100]} !important` : '#fff !important',
      border: isDarkMode() ? `${colors.blue[600]} !important` : `${colors.blue[500]} !important`,
      '& svg': {
        color: isDarkMode() ? `${colors.blue[100]} !important` : '#fff !important',
      },
    },
    ':focus': {
      backgroundColor: 'inherit !important',
      color: `${colors.blue[500]} !important`,
      border: 'inherit',
    },

    [breakpoints.down(620.05)]: {
      border: '0px !important',
      paddingRight: '0px !important',
      marginBottom: '0px !important',
      ':hover': {
        border: 'none !important',
        color: `${colors.blue[400]} !important`,
        backgroundColor: 'transparent !important',
      },
    },
  }),
  ({ disabled }) => ({
    ':disabled': { opacity: disabled ? 0.8 : 1, color: colors.blue[500], backgroundColor: 'inherit' },
  })
);

const closeButton = {
  marginRight: 4,
  color: isDarkMode() ? '#71B5E4' : '#2B8FD7',
  cursor: 'pointer',
  height: 14,
  width: 14,
};

interface CancelButtonProps {
  handleClick(e?: any): void;
  dataTestId: string;
  customStyle: any;
  disabled?: boolean;
}

const EditButton = ({ handleClick, dataTestId, disabled = false, customStyle }: CancelButtonProps): ReactElement => {
  return (
    <StyledEditButton data-test-id={dataTestId} onClick={handleClick} customStyle={customStyle} disabled={disabled}>
      <SvgIcon component={EditIcon} style={closeButton} />
      Edit
    </StyledEditButton>
  );
};

EditButton.defaultProps = {
  handleCancel: () => null,
  dataTestId: '',
  customStyle: {},
};

export default EditButton;
